import acc from "accounting";
import utils from "../../Utils/utils";
import React from 'react';

const icons = {
  'comments': '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewbox="0 0 24 24" fill="none"> <g clip-path="url(#clip0_37799_211190)"> <path d="M3 4H21V18H10.5L3 20V18V4Z" fill="#225AEA"/> <path d="M12 12C12.5523 12 13 11.5523 13 11C13 10.4477 12.5523 10 12 10C11.4477 10 11 10.4477 11 11C11 11.5523 11.4477 12 12 12Z" fill="white"/> <path d="M16 12C16.5523 12 17 11.5523 17 11C17 10.4477 16.5523 10 16 10C15.4477 10 15 10.4477 15 11C15 11.5523 15.4477 12 16 12Z" fill="white"/> <path d="M8 12C8.55228 12 9 11.5523 9 11C9 10.4477 8.55228 10 8 10C7.44772 10 7 10.4477 7 11C7 11.5523 7.44772 12 8 12Z" fill="white"/> <path d="M19 3H5C4.20435 3 3.44129 3.31607 2.87868 3.87868C2.31607 4.44129 2 5.20435 2 6V21C2.00031 21.1772 2.04769 21.3511 2.1373 21.504C2.22691 21.6569 2.35553 21.7832 2.51 21.87C2.65946 21.9547 2.82821 21.9995 3 22C3.17948 21.9999 3.35564 21.9516 3.51 21.86L8 19.14C8.16597 19.0412 8.35699 18.9926 8.55 19H19C19.7956 19 20.5587 18.6839 21.1213 18.1213C21.6839 17.5587 22 16.7956 22 16V6C22 5.20435 21.6839 4.44129 21.1213 3.87868C20.5587 3.31607 19.7956 3 19 3ZM20 16C20 16.2652 19.8946 16.5196 19.7071 16.7071C19.5196 16.8946 19.2652 17 19 17H8.55C8.00382 16.9996 7.46789 17.1482 7 17.43L4 19.23V6C4 5.73478 4.10536 5.48043 4.29289 5.29289C4.48043 5.10536 4.73478 5 5 5H19C19.2652 5 19.5196 5.10536 19.7071 5.29289C19.8946 5.48043 20 5.73478 20 6V16Z" fill="#225AEA"/> </g> <defs> <clip-path id="clip0_37799_211190"> <rect width="24" height="24" fill="white"/> </clip-path> </defs> </svg>',
  'reactions': '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewbox="0 0 24 24" fill="none"> <path d="M23.2875 10.6875C23.25 10.5375 23.25 10.3875 23.1749 10.2375C22.95 9.45002 22.425 8.77502 21.75 8.43752C21.1125 8.13752 20.4375 8.13752 19.9125 8.13752L15.9375 8.17502L16.5 5.58752C16.6125 5.13752 16.725 4.53752 16.5375 3.93752C16.2375 2.85002 15.075 2.17502 13.9875 2.43752C13.3125 2.62502 12.825 3.07502 12.4875 3.41252C12.3 3.60002 12 3.90002 11.625 4.23752C8.09995 7.68752 7.42495 8.43752 7.23745 8.85002C7.04995 9.33752 7.01245 9.82502 7.01245 10.35V18.2625C7.01245 18.9 7.01245 20.025 7.76245 20.775C8.51245 21.525 9.59995 21.5625 10.275 21.5625C10.3125 21.5625 10.3125 21.5625 10.35 21.5625H17.5125C17.9625 21.5625 18.5625 21.5625 19.125 21.2625C19.9125 20.85 20.25 20.025 20.475 19.5C23.025 13.5375 23.175 12.5625 23.2125 12.225C23.3625 11.6625 23.3624 11.175 23.2875 10.6875ZM21.6 12C21.5625 12.3375 21.1875 13.65 18.975 18.8625C18.7875 19.275 18.6 19.6875 18.375 19.8C18.1875 19.9125 17.85 19.9125 17.55 19.9125H10.3875C9.86245 19.9125 9.26245 19.875 8.99995 19.65C8.77495 19.3875 8.73745 18.8625 8.73745 18.3375V10.425C8.73745 10.0875 8.73745 9.82502 8.81245 9.60002C9.18745 9.07502 11.7 6.60002 12.825 5.55002C13.2 5.17502 13.5 4.87502 13.6875 4.68752C13.9125 4.46252 14.175 4.20002 14.4 4.12502C14.5875 4.08752 14.8875 4.23752 14.925 4.42502C15 4.65002 14.925 4.95002 14.85 5.25002L14.0625 8.85002C14.025 9.11252 14.0625 9.37502 14.25 9.56252C14.4 9.75002 14.6625 9.86252 14.925 9.86252L19.9875 9.82502C20.4 9.82502 20.775 9.82502 21.075 9.97502C21.3375 10.0875 21.525 10.3875 21.6375 10.725C21.675 10.8 21.675 10.875 21.675 10.95C21.675 11.25 21.675 11.5875 21.6 12Z" fill="#225AEA"/> <path d="M3.90005 9.0752H2.77505C1.61255 9.0752 0.675049 10.0127 0.675049 11.1752V19.5002C0.675049 20.6627 1.61255 21.6002 2.77505 21.6002H3.90005C5.06255 21.6002 6.00005 20.6627 6.00005 19.5002V11.1752C5.96255 10.0127 5.02505 9.0752 3.90005 9.0752ZM4.27505 19.5002C4.27505 19.7252 4.08755 19.9127 3.86255 19.9127H2.73755C2.51255 19.9127 2.32505 19.7252 2.32505 19.5002V11.1752C2.32505 10.9502 2.51255 10.7627 2.73755 10.7627H3.86255C4.08755 10.7627 4.27505 10.9502 4.27505 11.1752V19.5002Z" fill="#225AEA"/> <path d="M2 10H5L5.5 15.5L5 21H2L1.5 15.5L2 10Z" fill="#225AEA"/> <path d="M8.5 8L14.5 3.5L15.5 4L15 9H22L21.5 16L19.5 20.5H8L8.5 8Z" fill="#225AEA"/> </svg>',
  'shares': '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewbox="0 0 24 24" fill="none"> <g clip-path="url(#clip0_37799_211209)"> <path d="M5.5 11L11.25 8.75L14.5 5L17 6.5L20 10V11.5L15 15L14 14.5L13 13L8.5 14L4 17L5.5 11Z" fill="#225AEA"/> <path d="M3.7791 20.9996C4.00754 21.0062 4.23136 20.9345 4.41331 20.7962C4.59525 20.6579 4.72435 20.4615 4.7791 20.2396C5.22936 18.4556 6.22088 16.8547 7.6175 15.6568C9.01412 14.459 10.7473 13.7229 12.5791 13.5496V14.6696C12.5793 15.0199 12.6828 15.3623 12.8767 15.654C13.0706 15.9458 13.3462 16.1738 13.6691 16.3096C14.0192 16.4705 14.4084 16.5269 14.7899 16.4719C15.1713 16.4169 15.5287 16.2529 15.8191 15.9996L20.8791 11.5896C21.0731 11.4244 21.229 11.219 21.3358 10.9876C21.4427 10.7562 21.498 10.5044 21.498 10.2496C21.498 9.99474 21.4427 9.74293 21.3358 9.51157C21.229 9.2802 21.0731 9.07481 20.8791 8.90959L15.8191 4.48959C15.5249 4.2319 15.1615 4.06614 14.7741 4.01282C14.3866 3.95949 13.992 4.02095 13.6391 4.18959C13.3162 4.32537 13.0406 4.5534 12.8467 4.84513C12.6528 5.13686 12.5493 5.4793 12.5491 5.82959V6.99959C9.83288 7.20959 7.29403 8.43006 5.43353 10.4201C3.57303 12.4102 2.52602 15.0254 2.4991 17.7496C2.50047 18.5891 2.60458 19.4253 2.8091 20.2396C2.86385 20.4615 2.99295 20.6579 3.17489 20.7962C3.35684 20.9345 3.58066 21.0062 3.8091 20.9996H3.7791ZM13.5491 11.4996C11.8523 11.487 10.1754 11.8646 8.64781 12.6032C7.12022 13.3419 5.78288 14.4218 4.7391 15.7596C5.24002 13.8098 6.38015 12.0843 7.97723 10.8589C9.57432 9.63341 11.5361 8.97876 13.5491 8.99959C13.8143 8.99959 14.0687 8.89423 14.2562 8.70669C14.4437 8.51916 14.5491 8.2648 14.5491 7.99959V6.07959L19.3691 10.2496L14.5491 14.4596V12.4596C14.5388 12.2014 14.4289 11.9572 14.2424 11.7782C14.056 11.5992 13.8075 11.4994 13.5491 11.4996Z" fill="#225AEA"/> </g> <defs> <clip-path id="clip0_37799_211209"> <rect width="24" height="24" fill="white" transform="matrix(-1 0 0 1 24 0)"/> </clip-path> </defs> </svg>',
}


export const chartConfig = (
  type,
  animation,
  theme,
  kind,
  isMobile = false,
  externalTooltip = false,
  withRawData=false,
  withReturns = false,
) => {
  return type === 'ad_spot' && externalTooltip ?
    (
      {
        animation: !!animation,
        response: false,
        maintainAspectRatio: false,
        legend: {
          display: false,
        },
        layout: {
          autoPadding: false,
          padding: 0,
        },
        scales: {
          x: {
            adapters: {},
            type: 'time',
            time: {
              unit: 'day',
              displayFormats: {
                day: 'MMM DD',
                week: 'MMM DD',
                month: 'MMM DD',
                quarter: 'MMM DD',
                year: 'MMM',
              },
              tooltipFormat: 'MMM DD, YYYY',
            },
            ticks: {
              maxRotation: 0,
              padding: 4,
              maxTicksLimit: isMobile ? 6 : 11,
              color: '#707BA0',
              font: {
                family: 'Inter, sans-serif',
                weight: 400,
                size: 12,
                lineHeight: '16px',
              },
            },
            grid: {
              display: false,
              drawBorder: false,
            },
          },

          y: {
            beginAtZero: true,
            ticks: {
              align: 'center',
              padding: 8,
              color: '#707BA0',
              stepSize: kind === 'one' && 0.1,
              font: {
                family: 'Inter, sans-serif',
                weight: 400,
                size: 12,
                lineHeight: '16px',
              },
              callback: function(value) {
                let realValue = value || 0;
                if (realValue >= 1000000) return `${realValue / 1000000}M`;
                if (realValue >= 1000) return `${realValue / 1000}K`;
                return kind === 'empty' ? value * 10 : realValue;
              },
            },
            grid: {
              display: true,
              drawBorder: false,
              drawTicks: false,
              color: theme === 'light' ? '#F2F3F8' : '#151E3A',
            },
          },
        },
        plugins: {
          'vertical-line-plugin': { theme: theme },
          tooltip: {
            enabled: false,
            events: ['mousemove', 'mouseout'],
            position: 'nearest',
            external: (context) => externalTooltipHandler(context, isMobile)
          },
        },
        interaction: {
          mode: 'index',
          intersect: false,
        }
      }
    )
    :
    type === 'ad_spot' ?
      (
        {
          animation: !!animation,
          response: false,
          maintainAspectRatio: false,
          legend: {
            display: false,
          },
          layout: {
            autoPadding: false,
            padding: 0,
          },
          scales: {
            x: {
              adapters: {},
              type: 'time',
              time: {
                unit: 'day',
                displayFormats: {
                  day: 'MMM DD',
                  week: 'MMM DD',
                  month: 'MMM DD',
                  quarter: 'MMM DD',
                  year: 'MMM',
                },
                tooltipFormat: 'MMM DD, YYYY'
              },
              ticks: {
                maxRotation: 0,
                padding: 4,
                maxTicksLimit: isMobile ? 6 : 11,
                color: '#707BA0',
                font: {
                  family: 'Inter, sans-serif',
                  weight: 400,
                  size: 12,
                  lineHeight: '16px',
                },
              },
              grid: {
                display: false,
                drawBorder: false,
              }
            },

            y: {
              beginAtZero: true,
              ticks: {
                align: 'center',
                padding: 8,
                color: '#707BA0',
                stepSize: kind === 'one' && 0.1,
                font: {
                  family: 'Inter, sans-serif',
                  weight: 400,
                  size: 12,
                  lineHeight: '16px',
                },
                callback: function (value) {
                  let realValue = value || 0;
                  if (realValue >= 1000000) return `${realValue / 1000000}M`
                  if (realValue >= 1000) return `${realValue / 1000}K`
                  return kind === 'empty' ? value * 10 : realValue
                }
              },
              grid: {
                display: true,
                drawBorder: false,
                drawTicks: false,
                color: theme === 'light' ? '#F2F3F8' : '#151E3A',
              }
            },
          },
          plugins: {
            'vertical-line-plugin': {theme: theme},
            tooltip: {
              enabled: false,
              events: ['mousemove', 'mouseout'],
              position: 'nearest',
              external: (context) => externalTooltipSimpleHandler(context, isMobile)
            },
          },
          interaction: {
            mode: 'index',
            intersect: false,
          }
        }
      )
      :
      (
        {
          animation: !!animation,
          response: false,
          maintainAspectRatio: false,
          legend: {
            display: false,
          },
          layout: {
            autoPadding: false,
            padding: 0,
          },
          scales: {
            x: {
              adapters: {},
              type: 'time',
              time: {
                unit: 'day',
                displayFormats: {
                  day: 'MMM DD',
                  week: 'MMM DD',
                  month: 'MMM DD',
                  quarter: 'MMM DD',
                  year: 'MMM',
                },
                tooltipFormat: 'MMM DD, YYYY'
              },
              ticks: {
                maxRotation: 0,
                padding: 4,
                maxTicksLimit: isMobile ? 6 : 11,
                color: '#707BA0',
                font: {
                  family: 'Inter, sans-serif',
                  weight: 400,
                  size: 12,
                  lineHeight: '16px',
                },
              },
              grid: {
                display: false,
                drawBorder: false,
              }
            },

            y: {
              beginAtZero: true,
              ticks: {
                align: 'center',
                padding: 8,
                color: '#707BA0',
                stepSize: kind === 'one' && 0.1,
                font: {
                  family: 'Inter, sans-serif',
                  weight: 400,
                  size: 12,
                  lineHeight: '16px',
                },
                callback: function (value) {
                  let realValue = value || 0;
                  if (realValue >= 1000000) return `${realValue / 1000000}M`
                  if (realValue >= 1000) return `${realValue / 1000}K`
                  return kind === 'empty' ? value * 10 : realValue
                }
              },
              grid: {
                display: true,
                drawBorder: false,
                drawTicks: false,
                color: theme === 'light' ? '#F2F3F8' : '#151E3A',
              }
            },
          },
          plugins: {
            'vertical-line-plugin': {theme: theme},
            tooltip: {
              padding: {x: 16, y: 12},
              backgroundColor: '#151E3A',
              caretPadding: 16,
              caretSize: 0,
              displayColors: withReturns,
              titleColor: '#FFFFFF',
              titleFont: {
                family: 'Inter, sans-serif',
                weight: 500,
                size: 16,
                lineHeight: '24px',
              },
              titleAlign: 'center',
              bodyFont: {
                family: 'Inter, sans-serif',
                weight: 400,
                size: 14,
                lineHeight: '20px',
              },
              bodyAlign: withReturns ? 'left' : 'center',

              //hide tooltip stacking for boundary points (min, max)
              filter: function (tooltipItem) {
                return !tooltipItem?.raw?.hiddenTooltip
              },
              callbacks: {
                label: function (context) {
                  let label = ''
                  if (context?.raw?.invalid) {
                    label = context?.raw?.message || 'Invalid data';
                  } else if (context.parsed.y !== null) {
                    label = new Intl.NumberFormat(
                      'en-US',
                      type === 'revenue' ? {style: 'currency', currency: 'USD'} : {}
                    ).format(context.parsed.y);
                  }
                  let word = context?.dataset?.label;
                  return withRawData || withReturns ?
                    ` ${word.charAt(0).toUpperCase() + word.slice(1)}: ${label}`
                    :
                    label;
                },
                labelTextColor: function (context) {
                  return '#FFFFFF'
                },
                labelColor: function(context) {
                  return {
                    borderColor: context?.dataset?.borderColor,
                    backgroundColor: context?.dataset?.borderColor,
                    borderWidth: 3,
                    borderRadius: 7,
                  }
                }
              },
            },
          },
          interaction: {
            mode: 'index',
            intersect: false,
          },
        }
      )
}

function createTooltip(chart) {
  let tooltipElement = chart.canvas.parentNode.querySelector('div');

  if (!tooltipElement) {
    tooltipElement = document.createElement('div');
    tooltipElement.classList.add('ad-spot-external-tooltip');
    chart.canvas.parentNode.appendChild(tooltipElement);
  }

  return tooltipElement;
}

function externalTooltipSimpleHandler(context, isMobile) {
  const {chart, tooltip} = context;

  const tooltipElement = createTooltip(chart);

  if (tooltip.opacity === 0) {
    tooltipElement.style.opacity = 0;
    return;
  }

  tooltipElement.addEventListener('mouseover', () => tooltipElement.style.opacity = 1);
  tooltipElement.addEventListener('mouseout', () => {
    tooltipElement.style.opacity = 0;
    tooltip.setActiveElements([], {x: 0, y: 0})
  });

  if (tooltip.body) {
    const titleText = tooltip.title || [];
    const bodyText = tooltip.body.map(el => el?.lines);

    const tooltipHeader = document.createElement('div');
    tooltipHeader.classList.add('ad-spot-external-tooltip-header');

    titleText.forEach(el => {
      const span = document.createElement('span');
      const text = document.createTextNode(el);
      span.appendChild(text);
      tooltipHeader.appendChild(span);
    });

    const tooltipSubHeader = document.createElement('div');
    tooltipSubHeader.classList.add('ad-spot-external-tooltip-subheader');

    bodyText.forEach(el => {
      const span = document.createElement('span');
      const text = document.createTextNode(acc.formatNumber(el, 0, ','));
      span.appendChild(text);
      tooltipSubHeader.appendChild(span);
    });

    const divider = document.createElement('div');
    divider.classList.add('ad-spot-external-tooltip-divider');

    let subTitleStatus;
    let statusWrapper;
    let dividerStatus;

    if (tooltip?.dataPoints?.[0]?.raw?.is_active !== null) {

      subTitleStatus = document.createElement('h4');
      subTitleStatus.classList.add('ad-spot-external-tooltip-subtitle');
      const subTitleStatusText = document.createTextNode('ad status');
      subTitleStatus.appendChild(subTitleStatusText);

      statusWrapper = document.createElement('div');
      statusWrapper.classList.add('ad-spot-external-tooltip-status-wrapper');

      const statusCircle = document.createElement('div');
      statusCircle.classList.add('ad-spot-external-tooltip-status-circle');

      if (tooltip?.dataPoints?.[0]?.raw?.is_active) {
        statusCircle.classList.add('active');
      }

      const statusText = document.createTextNode(tooltip?.dataPoints?.[0]?.raw?.is_active ? 'active': 'inactive');
      statusWrapper.appendChild(statusCircle);
      statusWrapper.appendChild(statusText);

      dividerStatus = document.createElement('div');
      dividerStatus.classList.add('ad-spot-external-tooltip-divider');
    }

    const subTitle = document.createElement('h4');
    subTitle.classList.add('ad-spot-external-tooltip-subtitle');
    const subTitleText = document.createTextNode('engagement types');
    subTitle.appendChild(subTitleText);

    const topWrapper = document.createElement('div');
    topWrapper.classList.add('ad-spot-external-tooltip-top-wrapper');

      Object.keys(tooltip?.dataPoints?.[0]?.raw?.breakdown)?.forEach((performer) => {
        const topPerformer = document.createElement('div');
        topPerformer.classList.add('ad-spot-external-tooltip-top-item');

        const topPerformerImageWrapper = document.createElement('div');
        topPerformerImageWrapper.classList.add('ad-spot-external-tooltip-top-item-image-wrapper');
        topPerformerImageWrapper.classList.add('simple');
        topPerformerImageWrapper.innerHTML = icons[performer];

        const topPerformerTitle = document.createElement('span');
        topPerformerTitle.classList.add('ad-spot-external-tooltip-top-item-title');
        topPerformerTitle.classList.add('simple');
        const topPerformerTitleText = document.createTextNode(`${performer}`);
        topPerformerTitle.appendChild(topPerformerTitleText);

        const topPerformerValue = document.createElement('span');
        topPerformerValue.classList.add('ad-spot-external-tooltip-top-item-value');
        const topPerformerValueText = document.createTextNode(acc.formatNumber(tooltip?.dataPoints?.[0]?.raw?.breakdown?.[performer], 0, ','));
        topPerformerValue.appendChild(topPerformerValueText);

        topPerformer.appendChild(topPerformerImageWrapper);
        topPerformer.appendChild(topPerformerTitle);
        topPerformer.appendChild(topPerformerValue);

        topWrapper.appendChild(topPerformer);
      })

    while (tooltipElement.firstChild) {
      tooltipElement.firstChild.remove()
    }

    tooltipElement.appendChild(tooltipHeader);
    tooltipElement.appendChild(tooltipSubHeader);
    tooltipElement.appendChild(divider);
    if (tooltip?.dataPoints?.[0]?.raw?.is_active !== null) {
      tooltipElement.appendChild(subTitleStatus);
      tooltipElement.appendChild(statusWrapper);
      tooltipElement.appendChild(dividerStatus);
    }
    tooltipElement.appendChild(subTitle);
    tooltipElement.appendChild(topWrapper);

    const {offsetLeft: positionX, offsetTop: positionY} = chart.canvas;
    tooltipElement.style.opacity = 1;

    tooltipElement.style.left = isMobile ?
      tooltip?.caretX > 250 ?
        tooltip?.caretX - 100 + 'px'
        :
        tooltip?.caretX < 100 ?
          100 + tooltip.caretX + 'px'
          :
          positionX + tooltip.caretX + 'px'
      :
      tooltip?.caretX > 900 ?
        - positionX - 112  + tooltip.caretX + 'px'
        :
        tooltip?.caretX < 90 ?
          115 + tooltip?.caretX/2 + 'px'
          :
          positionX + tooltip.caretX + 'px';
    tooltipElement.style.top = -20 + 'px';
  }
}

function externalTooltipHandler(context, isMobile) {
  const {chart, tooltip} = context;

  const tooltipElement = createTooltip(chart);

  if (tooltip.opacity === 0) {
    tooltipElement.style.opacity = 0;
    return;
  }

  tooltipElement.addEventListener('mouseover', () => tooltipElement.style.opacity = 1);
  tooltipElement.addEventListener('mouseout', () => {
    tooltipElement.style.opacity = 0;
    tooltip.setActiveElements([], {x: 0, y: 0})
  });

  if (tooltip.body) {
    const titleText = tooltip.title || [];
    const bodyText = tooltip.body.map(el => el?.lines);

    const tooltipHeader = document.createElement('div');
    tooltipHeader.classList.add('ad-spot-external-tooltip-header');

    titleText.forEach(el => {
      const span = document.createElement('span');
      const text = document.createTextNode(el);
      span.appendChild(text);
      tooltipHeader.appendChild(span);
    });

    const tooltipSubHeader = document.createElement('div');
    tooltipSubHeader.classList.add('ad-spot-external-tooltip-subheader');

    bodyText.forEach(el => {
      const span = document.createElement('span');
      const text = document.createTextNode(acc.formatNumber(el, 0, ','));
      span.appendChild(text);
      tooltipSubHeader.appendChild(span);
    });

    const divider = document.createElement('div');
    divider.classList.add('ad-spot-external-tooltip-divider');

    let subTitleStatus;
    let statusWrapper;
    let dividerStatus;

    if (tooltip?.dataPoints?.[0]?.raw?.is_active !== null) {

      subTitleStatus = document.createElement('h4');
      subTitleStatus.classList.add('ad-spot-external-tooltip-subtitle');
      const subTitleStatusText = document.createTextNode('ad status');
      subTitleStatus.appendChild(subTitleStatusText);

      statusWrapper = document.createElement('div');
      statusWrapper.classList.add('ad-spot-external-tooltip-status-wrapper');

      const statusCircle = document.createElement('div');
      statusCircle.classList.add('ad-spot-external-tooltip-status-circle');

      if (tooltip?.dataPoints?.[0]?.raw?.is_active) {
        statusCircle.classList.add('active');
      }

      const statusText = document.createTextNode(tooltip?.dataPoints?.[0]?.raw?.is_active ? 'active': 'inactive');
      statusWrapper.appendChild(statusCircle);
      statusWrapper.appendChild(statusText);

      dividerStatus = document.createElement('div');
      dividerStatus.classList.add('ad-spot-external-tooltip-divider');
    }

    const subTitle = document.createElement('h4');
    subTitle.classList.add('ad-spot-external-tooltip-subtitle');
    const subTitleText = document.createTextNode('top performers');
    subTitle.appendChild(subTitleText);

    const topWrapper = document.createElement('div');
    topWrapper.classList.add('ad-spot-external-tooltip-top-wrapper');

    if (tooltip?.dataPoints?.[0]?.raw?.top_performers?.length) {
      tooltip?.dataPoints?.[0]?.raw?.top_performers?.forEach((performer, index) => {
        const topPerformer = document.createElement('div');
        topPerformer.classList.add('ad-spot-external-tooltip-top-item');

        const topPerformerImageWrapper = document.createElement('div');
        topPerformerImageWrapper.classList.add('ad-spot-external-tooltip-top-item-image-wrapper');

        const topPerformerImage = document.createElement('img');
        topPerformerImage.classList.add('ad-spot-external-tooltip-top-item-image');
        topPerformerImage.setAttribute('src', performer?.thumbnail);
        topPerformerImage.setAttribute('alt', '');
        topPerformerImage.onerror = utils.addDefaultSrc;

        topPerformerImageWrapper.appendChild(topPerformerImage);

        const topPerformerTitle = document.createElement('span');
        topPerformerTitle.classList.add('ad-spot-external-tooltip-top-item-title');
        const topPerformerTitleText = document.createTextNode(
          performer?.is_current_ad ?
            'Current ad'
              :
            `Ad ${index + 1}`
        );
        topPerformerTitle.appendChild(topPerformerTitleText);
        if (!performer?.is_current_ad)
        topPerformerTitle.addEventListener('click', () => {
          let params = new URLSearchParams(window.location.search);
          let result = `/ad-spot/${performer?.advertiser?.id}/overview/?ad_id=${performer?.id}&domain=${performer?.domain_fld}`;
          if (params.get('internal_shop_id')) result += `&internal_shop_id=${params.get('internal_shop_id')}`
          window.open(result, '_self');
        })

        const topPerformerValue = document.createElement('span');
        topPerformerValue.classList.add('ad-spot-external-tooltip-top-item-value');
        const topPerformerValueText = document.createTextNode(acc.formatNumber(performer?.value, 0, ','));
        topPerformerValue.appendChild(topPerformerValueText);

        topPerformer.appendChild(topPerformerImageWrapper);
        topPerformer.appendChild(topPerformerTitle);
        topPerformer.appendChild(topPerformerValue);

        topWrapper.appendChild(topPerformer);
      })
    } else {
      const topPerformer = document.createElement('span');
      topPerformer.classList.add('empty-message');
      const emptyText = document.createTextNode('No Top Performers');
      topPerformer.appendChild(emptyText);
      topWrapper.appendChild(topPerformer);
    }

    while (tooltipElement.firstChild) {
      tooltipElement.firstChild.remove()
    }

    tooltipElement.appendChild(tooltipHeader);
    tooltipElement.appendChild(tooltipSubHeader);
    tooltipElement.appendChild(divider);
    if (tooltip?.dataPoints?.[0]?.raw?.is_active !== null) {
      tooltipElement.appendChild(subTitleStatus);
      tooltipElement.appendChild(statusWrapper);
      tooltipElement.appendChild(dividerStatus);
    }
    tooltipElement.appendChild(subTitle);
    tooltipElement.appendChild(topWrapper);

    const {offsetLeft: positionX, offsetTop: positionY} = chart.canvas;
    tooltipElement.style.opacity = 1;

    tooltipElement.style.left = isMobile ?
      tooltip?.caretX > 250 ?
        tooltip?.caretX - 100 + 'px'
        :
        tooltip?.caretX < 100 ?
          100 + tooltip.caretX + 'px'
          :
          positionX + tooltip.caretX + 'px'
      :
      tooltip?.caretX > 900 ?
        - positionX - 112  + tooltip.caretX + 'px'
        :
        tooltip?.caretX < 90 ?
          115 + tooltip?.caretX/2 + 'px'
          :
          positionX + tooltip.caretX + 'px';
    tooltipElement.style.top = -20 + 'px';
  }
}
